import { combineReducers } from 'redux';

import { ActionTypes as ListingActionTypes } from '../../../../entities/listings/actions';

export const loadingProperty = (state = false, action: any = {} as any) => {
	switch (action.type) {
		case 'PROPERTY_GET_BY_ID_REQUEST':
			return true;
		case 'PROPERTY_GET_BY_ID_RECEIVE':
		case 'PROPERTY_GET_BY_ID_FAILURE':
			return false;
		default:
			return state;
	}
};

export const loadingListings = (state = false, action: any = {} as any) => {
	switch (action.type) {
		case ListingActionTypes.LISTINGS_BY_PROPERTY_ID_REQUEST:
			return true;
		case ListingActionTypes.LISTINGS_BY_PROPERTY_ID_RECEIVE:
		case ListingActionTypes.LISTINGS_BY_PROPERTY_ID_FAILURE:
			return false;
		default:
			return state;
	}
};

interface IBookingViewPageState {
	loadingProperty: ReturnType<typeof loadingProperty>;
	loadingListings: ReturnType<typeof loadingListings>;
}

const bookings = combineReducers<IBookingViewPageState>({
	loadingProperty,
	loadingListings
});

export default bookings;
